<template>
  <!-- Product Groups wrapper/iterator -->
  <div>
    <div
      v-for="(productGroup, productGroupIndex) in productGroups"
      :key="productGroupIndex"
      :qaid="`bundle-child-product-${productGroup.code}`"
      :product-group-index="productGroupIndex"
    >
      <pdl-collapse
        icon-active="indeterminate_check_box"
        icon-inactive="add_box"
        icon-position="left"
        align-icon="start"
        :default-active="false"
        :value="viewBreakpointMoreThan('medium') ? [productGroupIndex] : null"
        qaid="bulk-product-collapse"
      >
        <bulk-product-grid
          :hide-unavailable="hideUnavailable"
          :base-properties="baseProperties"
          :apple-table-headers="appleTableHeaders"
          :image-size="{width: 192, height: 144}"
          image-format="pjpeg"
          image-quality="60,1"
          image-unsharp-mask
          :base-product="baseProductCode"
          :product-group="productGroup"
          :product-type="productGroup.productType"
          :product-group-index="productGroupIndex"
          :is-pdp="true"
          :has-sku-footer-button="false"
          :has-link="false"
          column-config="BUNDLE"
        />
      </pdl-collapse>
    </div>
  </div>
</template>

<script>
import BulkProductGrid from '@/components/containers/bulk-product/BulkProductGrid';
import ProductGroups from '@/components/containers/bulk-product/utils/product-groups';
import {PdlCollapse} from '@pedal/pdl-collapse';
import viewSize from '@/mixins/view-size';

export default {
  components: {BulkProductGrid, PdlCollapse},
  mixins: [viewSize],
  props: {
    childProduct: {
      type: Object,
      required: true,
      default: () => {},
    },
    appleTableHeaders: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      hideUnavailable: false,
      productGroups: [],
    };
  },

  computed: {
    baseProductCode() {
      return !this.productGroups || !('code' in this.productGroups) ? '' : this.productGroups.code;
    },
  },

  mounted() {
    const productGroups = new ProductGroups(this.childProduct);
    this.productGroups = productGroups.getProductGroups();
  },
};
</script>
